import { IMAGE_ALT, imageSizeProps } from '../../seo/imageAltText';
import PictureImage from '../../components/Common/PictureImage';
import React from "react";
import { Link } from 'react-router-dom';
import "./Returnspage.css";
import { useStaggerReveal } from "../../hooks/useInViewOnce";



const CheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <circle cx="9" cy="9" r="9" fill="#28479e"/>
    <path d="M5 9L7.8 12L13 6" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);


const services: {
  label: string;
  img: string;
  desc: React.ReactNode;
  features: string[];
}[] = [
  {
    label: "Returns Management",
    img: "/returnhandling/Returns Management.jpg",
    desc: (
      <>
        Comprehensive return handling services managing every stage of your returns process — aligned with{' '}
        <Link to="/pricing-fulfilment-services">fulfilment pricing</Link> and clear SLAs from customer
        request to final resolution.
      </>
    ),
    features: ["	Automated return authorisation for faster returns processing", "	Real-time customer returns portal with complete visibility. ", "Full audit trail and returns reporting for total accountability"],
  },
  {
    label: "Return Handling",
    img: "/returnhandling/Return Handling.jpg",
    desc: (
      <>
        Professional return handling at our{' '}
        <Link to="/our-fulfilment-center">UK fulfilment centre</Link> ensures every returned item is
        received, inspected, documented, and processed accurately.
      </>
    ),
    features: ["Barcode scanning for accurate returns receiving and tracking. ", "Condition grading to determine restocking, repair, or disposal. ", "Photographic evidence captured for claims and quality assurance."],
  },
  {
    label: "Returns Processing",
    img: "/returnhandling/Returns Processing.jpg",
    desc: (
      <>
        Fast returns processing sorts, inspects, and routes stock for restocking into{' '}
        <Link to="/seller-fulfilled-prime-services">Seller Fulfilled Prime</Link>,{' '}
        <Link to="/fulfillment-by-merchant-services">Amazon FBM</Link>, or safe disposal.
      </>
    ),
    features: ["Same-day returns processing within agreed service level agreements.", "Multi-channel returns support for Amazon, Shopify, eBay, and more.", "	Automated refund workflows to speed up customer resolutions."],
  },
  {
    label: "Reverse Logistics",
    img: "/returnhandling/Reverse Logistics.jpg",
    desc: (
      <>
        Efficient reverse logistics for ecommerce brands — including guidance from our{' '}
        <Link to="/blog/ecommerce-fulfillment-trends-2026">ecommerce fulfilment trends 2026</Link> insights —
        so inventory recovery stays part of your supply chain.
      </>
    ),
    features: ["	Multi-carrier integration for flexible and reliable returns transportation.   ", "		Cost-optimised routing to reduce reverse logistics expenses.  ", "	Cross-border returns support for UK and international ecommerce sellers."],
  },
];


/* ─── Component ─────────────────────────────────────────── */
const ReturnsPage: React.FC = () => {
  const { refs: svcRefs, visible: svcVisible } = useStaggerReveal(services.length, 0.12, 110);
  // const { refs: capRefs, visible: capVisible } = useStagger(capabilities.length);
  // const { refs: procRefs, visible: procVisible } = useStagger(processes.length);

  return (
    <div className="rp2-root">

    

      {/* ══ SERVICES GRID ══════════════════════════════════ */}
      <section className="rp2-section rp2-section--light">
        <div className="rp2-container">
          <div className="rp2-section-head">
            {/* <span className="rp2-tag">Our Services</span> */}
            <h2 className="rp2-section-title">Complete Return Handling Services & Returns Management UK</h2>
            <p className="rp2-section-desc">
              Our integrated return handling services cover every stage of reverse logistics, helping ecommerce
              brands inspect, process, restock, and manage returns efficiently — including stock removed from
              Amazon FCs (see our{' '}
              <Link to="/blog/how-to-handle-amazon-removal-orders-uk">Amazon removal orders UK guide</Link>) and
              inventory you want to{' '}
              <Link to="/amazon-fba-prep-services">re-prep for FBA</Link> after grading.
            </p>
          </div>
          <div className="rp2-services-grid">
            {services.map((svc, i) => (
              <div
                key={i}
                ref={(el) => { svcRefs.current[i] = el; }}
                className={`rp2-svc-card ${svcVisible[i] ? "rp2-svc-card--visible" : ""}`}
              >
                <div className="rp2-svc-img-wrap">
                  <PictureImage src={svc.img} alt={IMAGE_ALT.returnsService(svc.label)} className="rp2-svc-img" {...imageSizeProps(svc.img)} loading="lazy" />
                  <div className="rp2-svc-img-overlay" />
                  <span className="rp2-svc-label-badge">{svc.label}</span>
                </div>
                <div className="rp2-svc-body">
                  <p className="rp2-svc-desc">{svc.desc}</p>
                  <ul className="rp2-svc-features">
                    {svc.features.map((f, j) => (
                      <li key={j}><CheckIcon /><span>{f}</span></li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

   

    </div>
  );
};

export default ReturnsPage;
